module.exports = __webpack_public_path__ + "static/media/tired-regular-active.405182f1.svg";